// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Moved to importmaps:
// - Web components
// - ActiveStorage
// - SSN formatting

import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel'
// collapse usage:
// - navbar
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover'
// import 'bootstrap/js/dist/scrollspy'
// import 'bootstrap/js/dist/tab'
// import 'bootstrap/js/dist/toast'
// import 'bootstrap/js/dist/tooltip'
// Load js from ViewComponent components (https://viewcomponent.org) from /app/components/**/*.js
import '../view_components';

import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';

// popper usage:
// - navbar
require('@popperjs/core');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

document.addEventListener('DOMContentLoaded', () => {

  const removeFieldsClickHandler = (e) => {
    const el = e.target;
    el.previousElementSibling.setAttribute('value', 1);
    el.closest('fieldset').style.display = 'none';
    return e.preventDefault();
  };

  const removeFieldsAddClickListener = () => {
    document.querySelectorAll('form a.remove_fields').forEach((el) => {
      el.addEventListener('click', removeFieldsClickHandler);
    });
  };

  removeFieldsAddClickListener();

  document.querySelector('form a.add_fields')?.addEventListener('click', (e) => {
    const el = e.target;
    const time = new Date().getTime();
    const dataId = el.getAttribute('data-id');
    const regexp = new RegExp(dataId, 'g');
    const fields = el.getAttribute('data-fields');
    const newFields = fields.replace(regexp, time);
    el.insertAdjacentHTML('beforebegin', newFields);

    removeFieldsAddClickListener();

    return e.preventDefault();
  });

});


// Support component names relative to this directory:
var componentRequireContext = require.context('../components', false);
var ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);
ReactRailsUJS.handleEvent('turbo:load', ReactRailsUJS.handleMount);
ReactRailsUJS.handleEvent('turbo:before-render', ReactRailsUJS.handleUnmount);
